export const earn = {
    jdzb: "Earn Sederhana",
    jryd: "Keuangan yang Terkelola, Maju Bersama",
    jrbk: "Bergabung dengan Biking Earn Sederhana, inovasi tanpa batas untuk memaksimalkan pendapatan aset digital Anda",
    zbz: "Sedang Earn",
    ljsy: "Pendapatan Kumulatif",
    zrsy: "Pendapatan Kemarin",
    hq: "Flexible",
    dq: "Fixed",
    cknh: "Perkiraan Tahunan",
    sqjd: "Progress Pembelian",
    sg: "Beli",
    qbcp: "Semua Produk",
    cz: "Reset",
    qx: "Jangka Waktu",
    question1: "1. Apa itu Earn?",
    question1_text: "Earn adalah platform layanan one-stop yang dibangun BIKING untuk membantu pengguna menemukan berbagai peluang produk hold. Saat ini meluncurkan Earn Sederhana yaitu Flexible Savings (dapat disetor dan ditarik kapan saja), selanjutnya akan merilis lebih banyak produk untuk memberikan pilihan produk yang beragam bagi pengguna.",
    question2: "2. Apa itu Perkiraan Tahunan?",
    question2_text: "Pendapatan Earn saat ini adalah bunga dari token yang disetor. Perkiraan Tahunan adalah bunga tahunan dari token yang disetor, misalnya 1000U pertama suatu produk memiliki Perkiraan Tahunan 12%, lebih dari 1000U pertama memiliki Perkiraan Tahunan 2%, total Perkiraan Tahunan bunga adalah 14%.",
    question3: "3. Kapan bunga mulai/berakhir?",
    question3_text: "Saat membeli produk yang berbeda, waktu mulai/berakhir bunga mungkin berbeda. Mengambil contoh Earn Sederhana USDT dengan bunga harian, produk flexible USDT mulai mendapat bunga pada jam 2 pagi hari berikutnya (UTC+8), bunga hari sebelumnya diselesaikan dan dibagikan pada jam 5 pagi (UTC+8) waktu T+1 (yaitu waktu pembelian T+2);",
    question4: "4. Apa itu Sisa yang Dapat Diinvestasikan?",
    question4_text: "Sisa yang Dapat Diinvestasikan adalah jumlah yang masih dapat Anda beli dari produk keuangan tersebut<br/>Sisa yang Dapat Diinvestasikan = Total kuota produk yang dapat dibeli - Jumlah yang telah Anda beli",
    xzmbfs: "Pilih metode setor/beli",
    nhsyl: "Tingkat Pengembalian Tahunan dan jangka waktu:",
    sl: "Jumlah",
    qitou: "Investasi Minimum",
    max: "Maksimum",
    kzcsl: "Ini adalah jumlah yang dapat ditarik dari akun dana",
    sykt: "Sisa yang Dapat Diinvestasikan",
    syktsl: "Sisa yang Dapat Diinvestasikan adalah jumlah yang masih dapat Anda beli",
    syktsx: "Sisa yang Dapat Diinvestasikan = Total kuota produk yang dapat dibeli - Jumlah yang telah Anda beli (tidak lebih dari batas investasi pribadi {amount}{coin})",
    jlgz: "Aturan Hadiah",
    jd1: "Tahap 1: {amount}{coin} pertama",
    ptjl: "Hadiah Platform",
    jd2: "Tahap 2: Lebih dari {amount}{coin} pertama",
    jd22: "Tahap",
    jd3: "Tahap 3: Lebih dari {amount}{coin}",
    grsgsx: "Batas pembelian pribadi adalah {amount}{coin}",
    gz: "Aturan",
    sgsj: "Waktu Pembelian",
    xianzai: "Sekarang",
    qxsj: "Waktu Mulai Bunga",
    lxrz: "Pencatatan Bunga",
    c2c: "Beli Koin C2C",
    lhxz: "Pilihan fleksibel, harga lebih baik",
    lcjd: "Proses sederhana, transaksi cepat",
    crszhb: "Setor aset digital dari dompet atau exchange",
    zcsl: "Jumlah Aset",
    dzsy: "Pendapatan yang Diterima",
    lcxx: "Informasi Keuangan",
    zt: "Status",
    sh: "Tebus",
    sgje: "Jumlah Pembelian",
    sgzj: "{amount}{coin} pertama dari dana pembelian dapat menghasilkan {value}% hadiah tahunan",
    dyklqje: "Lebih dari {amount}{coin} dapat menghasilkan {value}% hadiah tahunan",
    grsged: "Kuota pembelian pribadi adalah {amount}～{amount2}{coin}",
    shsl: "Jumlah Penebusan",
    srshsl: "Masukkan jumlah penebusan",
    ksh: "Dapat ditebus:",
    haode: "Oke",
    sgcg: "Pembelian Berhasil",
    shcg: "Penebusan Berhasil",
    zcsg: "Beli Lagi",
    sjdzsl: "Jumlah Aktual yang Diterima",
    shsj: "Waktu Penebusan",
    jssj: "Waktu Penyelesaian",
    yjsdd: "Pesanan Telah Diselesaikan",
    jyjl: "Riwayat Transaksi",
    hqjdzb: "Earn Sederhana Flexible",
    sy: "Pendapatan",
    wwc: "Belum Selesai",
    xmlx: "Jenis Proyek",
    hqjdzbcp: "Earn Sederhana Flexible adalah produk keuangan aman yang dibangun Biking, mendukung setor dan tarik 24 jam, bunga dihitung per jam",
    nh: "Tahunan",
    zhzchz: "Transfer antar akun aset, sederhana dan cepat",
    qsrsl: "Silakan masukkan jumlah",
    yjssymx: "Detail Pendapatan yang Telah Diselesaikan",
    mx: "Detail",
    qwsmrz: "Pergi ke Verifikasi Identitas",
    jxwcsmrz: "1. Aktivitas ini hanya untuk pengguna yang telah menyelesaikan verifikasi identitas, setiap pengguna hanya memiliki satu kesempatan untuk berpartisipasi",
    dqcked: "2. Kuota deposito fixed setiap pengguna adalah {min}~{max}{coin}, pada jatuh tempo sistem akan otomatis menebus ke akun",
    cpbntjsh: "3. Produk ini tidak dapat ditebus lebih awal",
    anzh: "4. Setelah produk habis terjual, total pool 0, tombol dinonaktifkan",
    smrzyh: "Aktivitas hanya untuk pengguna yang telah menyelesaikan verifikasi identitas,",
    jxcjyc: "Setiap pengguna yang memenuhi syarat hanya dapat berpartisipasi sekali",
    ygsy: "Perkiraan Pendapatan",
    scqx: "Periode Lock",
    qixian: "Hari ke-{min} (Total {max} hari)",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/earn/ba.js